import { loadCldr } from '@syncfusion/ej2-base';

import cldrCalendar from 'cldr-data/main/en-GB/ca-gregorian.json';
import cldrNumbers from 'cldr-data/main/en-GB/numbers.json';
import cldrTimeZoneNames from 'cldr-data/main/en-GB/timeZoneNames.json';
import cldrWeekData from 'cldr-data/supplemental/weekData.json';

loadCldr(cldrCalendar, cldrNumbers, cldrTimeZoneNames, cldrWeekData);
